// @ts-ignore
import PlaceholderIconCenter from 'assets/images/placeholders/placeHolderIconCenter.jpg';
// @ts-ignore
import PlaceholderIconRight from 'assets/images/placeholders/placeHolderIconRight.jpg';

export const PLACEHOLDER_ICON_CENTER = PlaceholderIconCenter;
export const PLACEHOLDER_ICON_RIGHT = PlaceholderIconRight;
